import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../../controls/Controls";
import { useForm, Form } from "../../../../controls/useForm";

const initialFValues = {
  paymentType: "",
  customerName: "",
  accountId: 0,
  phoneNumber: "",
  paymentTypeId: 0,
  accountTypeId: 0,
  cardTypeId: 0,
};

export default function ProductForm(props) {
  const {
    addOrEdit,
    recordForEdit,
    accounts,
    accountTypes,
    cardtypes,
    paymentTypes,
  } = props;
  const [file, setFile] = useState(null);
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  var fileRecord = null;
  var state = {
    currentFile: undefined,
    previewImage: undefined,
    progress: 0,
    message: "",
    isError: false,
    imageInfos: [],
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  console.log("Credit Details", initialFValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var data = { ...values, formFile: file };
      addOrEdit(data, resetForm);
    }
  };

  useEffect(() => {
    console.log(recordForEdit);
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="paymentType"
            label="Amount Oustanding"
            value={values.amountOutstanding || ""}
            onChange={handleInputChange}
            readonly={true}
          />
          <Controls.Input
            label="Financing Charges"
            name="amountOutsanding"
            value={values.financingCharges || ""}
            onChange={handleInputChange}
            readonly={true}
          />

          <Controls.Input
            label="Store Location"
            name="repaymentPlanId"
            value={values.location || ""}
            onChange={handleInputChange}
            readonly={true}
          />
          <Controls.Input
            name="customerName"
            label="Customer Name"
            value={values.customerName || ""}
            onChange={handleInputChange}
            readonly={true}
          />
        </Grid>
        <Grid item xs={6}>
          {/* <Controls.Input
            name="creditTenour"
            label="Credit Tenour"
            value={values.creditTenour || ''}
            onChange={handleInputChange}
            readonly={true}
          /> */}
          <Controls.Input
            name="date"
            label="Date"
            value={values.dateCreated || ""}
            onChange={handleInputChange}
            readonly={true}
          />

          <Controls.Input
            label="Payment Frequency"
            name="referenceNumber"
            value={values.paymentFrequencyName}
            onChange={handleInputChange}
            readonly={true}
          />
          <Controls.Input
            label="Repayment"
            name="referenceNumber"
            value={values.repayment || 0}
            onChange={handleInputChange}
            readonly={true}
          />
           <Controls.Input
            label="Amount Payable"
            name="referenceNumber"
            value={values.totalAmountPayable || 0}
            onChange={handleInputChange}
            readonly={true}
          />
           <Controls.Input
            label="Sold By"
            name="referenceNumber"
            value={values.soldBy || 0}
            onChange={handleInputChange}
            readonly={true}
          />
            <Controls.Input
            label="Credit Tenure"
            name="referenceNumber"
            value={values.creditTenour || 0}
            onChange={handleInputChange}
            readonly={true}
          />
           <Controls.Input
            label="DateCreated"
            name="referenceNumber"
            value={values.dateCreated || 0}
            onChange={handleInputChange}
            readonly={true}
          />


          <Controls.Input
            label="Transaction Reference"
            name="phoneNumber"
            value={values.transactionReference || ""}
            onChange={handleInputChange}
            readonly={true}
          />
        </Grid>
      </Grid>
    </Form>
  );
}
